import BaseService from '@Core/axios/BaseService'
class History extends BaseService {
	BASE_ENDPOINT = '/quizexam/studio/api/v1/admin/exam-create-histories'

	paramsGet = {
		sort: 'updated_at',
		dir: 'desc',
		create_type: 'ai_upload_file_quiz',
		version: 2
	}

	constructor() {
		super()
		// this.BASE_URL = 'http://127.0.0.1:8080'
		this.setRequest()
	}
}

const adminExamCreateHistoryService = new History()

export default adminExamCreateHistoryService
